"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _mergeTheme = _interopRequireDefault(require("../style/mergeTheme"));

var _icon = _interopRequireDefault(require("./style/icon"));

var _root = _interopRequireDefault(require("./style/root"));

var _wrapper = _interopRequireDefault(require("./style/wrapper"));

var _reactSpring = require("react-spring");

var _ripple = _interopRequireDefault(require("./style/ripple"));

var IconButton = function IconButton(_ref) {
  var children = _ref.children,
      icon = _ref.icon,
      title = _ref.title,
      width = _ref.width,
      height = _ref.height,
      disabled = _ref.disabled,
      ripple = _ref.ripple,
      rippleColor = _ref.rippleColor,
      iconFx = _ref.iconFx,
      onClick = _ref.onClick,
      className = _ref.className,
      theme = _ref.theme,
      style = _ref.style;

  var _useState = (0, _react.useState)([]),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      timers = _useState2[0],
      setTimers = _useState2[1];

  var timerCallbacks = (0, _react.useMemo)(function () {
    return {};
  }, []);
  var removeRipple = (0, _react.useCallback)(function (key) {
    setTimers(timers.filter(function (item) {
      return item !== key;
    }));
  }, []);
  var addRipple = (0, _react.useCallback)(function () {
    return setTimers([].concat((0, _toConsumableArray2["default"])(timers), ["ripple".concat(new Date().getTime())]));
  }, []);
  var memoTheme = (0, _react.useMemo)(function () {
    return (0, _mergeTheme["default"])(theme, style);
  }, [style]);
  (0, _react.useEffect)(function () {
    timers.forEach(function (key) {
      if (!timerCallbacks[key]) {
        timerCallbacks[key] = setTimeout(function () {
          return removeRipple(key);
        }, 1000);
      }
    });
    return function () {
      return Object.values(timerCallbacks).map(function (cb) {
        return clearTimeout(cb);
      });
    };
  }, [timers]);
  var iconContent;

  if (children) {
    iconContent = _react["default"].createElement(_icon["default"], null, children);
  } else if (typeof icon === 'string') {
    iconContent = _react["default"].createElement("img", {
      src: icon,
      alt: title,
      width: width,
      height: height
    });
  } else {
    iconContent = _react["default"].createElement("div", {
      style: {
        width: width,
        height: height
      }
    }, icon);
  }

  var transition = (0, _reactSpring.useTransition)(timers, timers, {
    from: {
      x: 0
    },
    enter: {
      x: 1
    },
    "native": true,
    leave: true,
    immediate: disabled || !ripple,
    config: _reactSpring.config.slow
  });
  return _react["default"].createElement(_root["default"], {
    onClick: onClick,
    title: title,
    className: className,
    theme: memoTheme
  }, _react["default"].createElement(_wrapper["default"], {
    width: width,
    height: height,
    disabled: disabled,
    ripple: ripple,
    iconFx: iconFx,
    rippleColor: rippleColor,
    theme: memoTheme,
    onClick: addRipple
  }, transition.map(function (_ref2) {
    var item = _ref2.item,
        props = _ref2.props,
        key = _ref2.key;
    return item && _react["default"].createElement(_ripple["default"], {
      theme: memoTheme,
      key: key,
      style: {
        background: rippleColor,
        transform: props.x.interpolate({
          range: [0, 0.25, 0.75, 1],
          output: [0, 0.5, 2, 1.33]
        }).interpolate(function (x) {
          return "scale(".concat(x, ")");
        }),
        opacity: props.x.interpolate({
          range: [0, 0.5, 0.75, 1],
          output: [0, 0.24, 0, 0]
        }).interpolate(function (x) {
          return x;
        })
      }
    });
  }), iconContent));
};

IconButton.propTypes = {
  /**
   * any supported image or url
   */
  icon: _propTypes["default"].any,
  rippleColor: _propTypes["default"].string.isRequired,
  ripple: _propTypes["default"].bool,

  /**
   * only for single color svg icons
   * adds filter fx for every state
   */
  iconFx: _propTypes["default"].bool,
  title: _propTypes["default"].string,
  width: _propTypes["default"].number.isRequired,
  height: _propTypes["default"].number.isRequired,
  disabled: _propTypes["default"].bool,

  /**
   * Basic style
   */
  theme: _propTypes["default"].shape({
    /**
     * @default inline-block
     */
    display: _propTypes["default"].string,

    /**
     * @default pointer
     */
    cursor: _propTypes["default"].string,

    /**
     * @default 50%
     */
    rippleBorderRadius: _propTypes["default"].string,

    /**
     * @default {opacity: 0.38}
     */
    idleIconFx: _propTypes["default"].object,

    /**
     * @default {opacity: 0.87}
     */
    hoverIconFx: _propTypes["default"].object,

    /**
     * @default {opacity: 1}
     */
    activeIconFx: _propTypes["default"].object,

    /**
     * @default {opacity: 0.24}
     */
    disabledIconFx: _propTypes["default"].object,

    /**
     * @default {transform: 'scale(0)', opacity: 0}
     */
    idleRippleFx: _propTypes["default"].object,

    /**
     * @default {transform: 'scale(1.33)', opacity: 0.08}
     */
    hoverRippleFx: _propTypes["default"].object,

    /**
     * @default {transform: 'scale(1.33)', opacity: 0.24}
     */
    activeRippleFx: _propTypes["default"].object
  })
};
IconButton.defaultProps = {
  ripple: true,
  iconFx: true,
  width: 24,
  height: 24,
  rippleColor: '#000'
};
var _default = IconButton;
exports["default"] = _default;